import { usePrivateAddOnFeatures } from '~/hooks/usePrivateAddOnFeatures';
import { useCurrentWorkspaceAddOns } from '~/swr-hooks/workspaces/addOns/useCurrentWorkspaceAddOns';

/**
 * Whether the workspace `agentSessions` add-on is enabled and visible for automations UI
 * (`GET …/add-ons`). Does not include the `automationsEnabled` LaunchDarkly flag — combine with
 * that flag in `useAutomationsAccess`. `workspace.canManageAutomations` is enforced there too.
 */
export const useIsAutomationsUiAvailable = (): boolean => {
  const { agentSessions } = usePrivateAddOnFeatures();
  const { isPending: areAddOnsPending } = useCurrentWorkspaceAddOns({ enabled: true });

  if (areAddOnsPending || agentSessions === undefined) {
    return false;
  }

  return agentSessions === true;
};
